/* Registrations.js */

"use strict";
module.exports = {
    SETTINGS_SECTION: "App.GameConsole.Section.Settings",
    MANAGE_MY_USER_SCREEN: "App.GameConsole.Section.Settings.Screens.ManageMyUser",
    // MANAGE_USERS_SCREEN: "App.GameConsole.Section.Settings.Screens.ManageUsers",
    MANAGE_CUSTOM_FIELDS_SCREEN: "App.GameConsole.Section.Settings.Screens.CustomFields",
    MANAGE_ZONES_SCREEN: "App.GameConsole.Section.Settings.Screens.Zone",
    OS_MANAGEMENT_SCREEN: "App.GameConsole.Section.Settings.Screens.OSManagement",
    MANAGE_INTEGRATIONS: "App.GameConsole.Section.Settings.Screens.Integrations",
    MANAGE_DATA_RET_SCREEN: "App.GameConsole.Section.Settings.Screens.ManageRet",
    MANAGE_ORGS_SCREEN: "App.GameConsole.Section.Settings.Screens.ManageOrgs",
    MANAGE_ROLES_SCREEN: "App.GameConsole.Section.Settings.Screens.ManageRoles",
    MANAGE_DASHBOARDS_SCREEN: "App.GameConsole.Section.Settings.Screens.ManageDashboards",
    MANAGE_LICENSES_SCREEN: "App.GameConsole.Section.Settings.Screens.Licensing",
    MANAGE_EVENTS_SCREEN: "App.GameConsole.Section.Settings.Screens.Events",
    MANAGE_OUTBOUND_SYSLOG_SCREEN: "App.GameConsole.Section.Settings.Screens.OutboundSyslog",
    SYSTEM_BANNER_SCREEN: "App.GameConsole.Section.Settings.Screens.Banner",
    SYSTEM_CONFIGURATION_SCREEN: "App.GameConsole.Section.Settings.Screens.Configuration",
    PRODUCT_INFO_SCREEN: "App.GameConsole.Section.Settings.Screens.ProductInformation",
    SINGLE_SIGN_ON_SCREEN: "App.GameConsole.Section.Settings.Screens.SingleSignOn",
    VAULTS_SCREEN: "App.GameConsole.Section.Settings.Screens.Vaults",
    CAPTURE_SCREEN: "App.GameConsole.Section.Settings.Screens.Capture",
    CMDB_SCREEN: "App.GameConsole.Section.Settings.Screens.CMDB",
    MANAGE_CONNECTIONS_SCREEN: "App.GameConsole.Section.Settings.Screens.ManageConnections",
};
Object.freeze(module.exports);
